import styled from 'styled-components';

export const FilterEmptyTxt = styled.div`
  text-align: center;
  font-size: 1rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin-top: 60px;
`;

export const ResetFiltersBtn = styled.button`
  border: 0;
  background: none;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 5px;
  outline: none;
`;
